export const COMMON_TITLE = 'Wabunka | Private Tours & Expert-Led Experiences in Japan';
